import { useDispatch } from 'react-redux';
import { IonCol, IonRow, IonCard, IonCardHeader, IonCardTitle, IonCardContent } from '@ionic/react';

import { setLoadPileType } from 'actions/ProjectDataActions';

export default function PileTypeSelction({load}) {
  const dispatch = useDispatch();
  const selectPileType = (type) => () => dispatch(setLoadPileType(load.id, type));

  return (
    <div className="narrow-container">
      <h3 className="ion-padding">Select a Product Type</h3>
      <IonRow>
        <IonCol>
          <IonCard className="ion-no-margin" button onClick={selectPileType('helical')}>
            <IonCardHeader>
              <IonCardTitle color="primary">Helical Pile</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              A helical pile is a deep foundation pile that is screwed into the ground while
              monitoring the amount of pressure or torque it requires to advance. The amount
              of torque can then be converted to confirm the load that the pile can hold. When
              the pile is completed the load from the structure is transferred to the bearing
              elements (helices) and distributed in a downward cone shape.
            </IonCardContent>
          </IonCard>
        </IonCol>
        <IonCol>
          <IonCard className="ion-no-margin" button onClick={selectPileType('push_pier')}>
            <IonCardHeader>
              <IonCardTitle color="primary">Push Pier</IonCardTitle>
            </IonCardHeader>
            <IonCardContent>
              A push pier is a deep foundation pier that is hydraulically driven into the ground
              while monitoring pressure. The pressure can be converted to determine how much load
              each pier can hold. The installation process essentially “load tests” each pier by
              placing the pressure directly to the top. When the pier is completed the load is
              transferred directly down the shaft to the base of the pier creating an “endbearing” pier.
            </IonCardContent>
          </IonCard>
          </IonCol>
      </IonRow>
    </div>
  );
}
